var managePrice = {

    init: function() {
        this.setEvents();
        this.updatePrice();
    },

    updatePrice: function() {
        if(!jQuery('body.template--product').length) {
            return;
        }

        var productIds = Object.keys(BoosterTheme.swatches.current);

        if(!productIds.length) {
          return;
        }

        var productId = productIds[0];
        var quantity = parseInt(document.querySelectorAll('.shopify-product-form [name="quantity"')[0].value);
        var variants = BoosterTheme.swatches.getVariants(productId);
        var updatedVariants = [];

        for(variantId in variants) {
            var variant = Object.assign({}, variants[variantId]);
            var price = variant.price_raw * quantity;

            variant.price_raw = price;
            variant.price = Shopify.formatMoney(price);

            var sale = variant.sale_raw * quantity;

            variant.sale_raw = sale;
            variant.sale = Shopify.formatMoney(sale);

            updatedVariants[variantId] = variant;
        }

        var productData = {
            selectedVariant: updatedVariants[BoosterTheme.swatches.findVariant(productId)],
            currentOptions: BoosterTheme.swatches.current[productId],
            product: {
                id: productId,
                variants: updatedVariants
            }
        };

        BoosterTheme.swatches.THEME_UTILS.selectSwatch(productData);
    },

    setEvents: function() {
        var _self = this;

        BoosterTheme.swatches.events.on(
            'booster:variant:select',
            function() {
                _self.updatePrice();
            }
        );
    }

};

function initManagePrice() {
    if(typeof BoosterTheme == 'undefined') {
        setTimeout(initManagePrice, 500);
        return;
    }
    managePrice.init();
}

jQuery(document).ready(
    function() {
        initManagePrice();
    }
);